import { render, staticRenderFns } from "./transactionHistoryModal.vue?vue&type=template&id=3d710554"
import script from "./transactionHistoryModal.vue?vue&type=script&lang=js"
export * from "./transactionHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports